"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Error = function Error(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: className,
    width: "36",
    height: "36",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "https://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.982 0C8.046 0 0 8.064 0 18C0 27.936 8.046 36 17.982 36C27.936 36 36 27.936 36 18C36 8.064 27.936 0 17.982 0ZM18 8C19.1 8 20 8.9 20 10V18C20 19.1 19.1 20 18 20C16.9 20 16 19.1 16 18V10C16 8.9 16.9 8 18 8ZM16 24V28H20V24H16Z",
    fill: "#E22B24"
  }));
};

var _default = Error;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9pY29ucy9FcnJvci50c3giXSwibmFtZXMiOlsiRXJyb3IiLCJjbGFzc05hbWUiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7OztBQUVBLElBQU1BLEtBQWlDLEdBQUcsU0FBcENBLEtBQW9DO0FBQUEsTUFBR0MsU0FBSCxRQUFHQSxTQUFIO0FBQUEsc0JBQ3hDO0FBQUssSUFBQSxTQUFTLEVBQUVBLFNBQWhCO0FBQTJCLElBQUEsS0FBSyxFQUFDLElBQWpDO0FBQXNDLElBQUEsTUFBTSxFQUFDLElBQTdDO0FBQWtELElBQUEsT0FBTyxFQUFDLFdBQTFEO0FBQXNFLElBQUEsSUFBSSxFQUFDLE1BQTNFO0FBQWtGLElBQUEsS0FBSyxFQUFDO0FBQXhGLGtCQUNFO0FBQ0UsSUFBQSxRQUFRLEVBQUMsU0FEWDtBQUVFLElBQUEsUUFBUSxFQUFDLFNBRlg7QUFHRSxJQUFBLENBQUMsRUFBQyxvT0FISjtBQUlFLElBQUEsSUFBSSxFQUFDO0FBSlAsSUFERixDQUR3QztBQUFBLENBQTFDOztlQVdlRCxLIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IEZDIH0gZnJvbSAncmVhY3QnO1xuXG5jb25zdCBFcnJvcjogRkM8eyBjbGFzc05hbWU/OiBzdHJpbmcgfT4gPSAoeyBjbGFzc05hbWUgfSkgPT4gKFxuICA8c3ZnIGNsYXNzTmFtZT17Y2xhc3NOYW1lfSB3aWR0aD1cIjM2XCIgaGVpZ2h0PVwiMzZcIiB2aWV3Qm94PVwiMCAwIDM2IDM2XCIgZmlsbD1cIm5vbmVcIiB4bWxucz1cImh0dHBzOi8vd3d3LnczLm9yZy8yMDAwL3N2Z1wiPlxuICAgIDxwYXRoXG4gICAgICBmaWxsUnVsZT1cImV2ZW5vZGRcIlxuICAgICAgY2xpcFJ1bGU9XCJldmVub2RkXCJcbiAgICAgIGQ9XCJNMTcuOTgyIDBDOC4wNDYgMCAwIDguMDY0IDAgMThDMCAyNy45MzYgOC4wNDYgMzYgMTcuOTgyIDM2QzI3LjkzNiAzNiAzNiAyNy45MzYgMzYgMThDMzYgOC4wNjQgMjcuOTM2IDAgMTcuOTgyIDBaTTE4IDhDMTkuMSA4IDIwIDguOSAyMCAxMFYxOEMyMCAxOS4xIDE5LjEgMjAgMTggMjBDMTYuOSAyMCAxNiAxOS4xIDE2IDE4VjEwQzE2IDguOSAxNi45IDggMTggOFpNMTYgMjRWMjhIMjBWMjRIMTZaXCJcbiAgICAgIGZpbGw9XCIjRTIyQjI0XCJcbiAgICAvPlxuICA8L3N2Zz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IEVycm9yO1xuIl19